<template>
  <div id="deleteConfirmModal">
    <b-modal
      id="delete-modal"
      :title="titleValue ? titleValue : 'حذف'"
      button-size="sm"
      @hidden="hideModal"
      :hide-footer="footer"
      ref="delete-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="text f_c_c w-100 mb-5 mt-4">
          {{ message }}
        </div>
        <div class="btnSection w-100 f-c-c">
          <div class="btnItem1 f_c_c ml-2" @click="deleteFunc()">
            {{ "بله" }}
          </div>
          <div class="btnItem2 f_c_c ml-2" @click="hideModal()">
            {{ "خیر" }}
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "DelConfirmModal",
  data() {
    return {
      footer: true,
    };
  },
  props: {
    message: String,
    titleValue: String
  },
  computed: {
    ...mapState({
      ltrRtl: (state) => state.login.ltrRtl,
    }),
  },
  methods: {
    deleteFunc() {
      EventBus.$emit("deleteItem", true);
    },
    hideModal() {
      EventBus.$emit("deleteItem", false);
    },
  },
  mounted() {
    this.$refs["delete-modal"].show();
  },
};
</script>

<style lang="scss" scoped>
</style>